var map = {
	"./Anyswap.png": 480,
	"./Anyswap.svg": 481,
	"./Artwork.svg": 482,
	"./Artwork_gmx.svg": 483,
	"./Banxa.png": 484,
	"./DROP_DOWN.svg": 284,
	"./Frame.svg": 485,
	"./Hop.png": 486,
	"./Hop.svg": 487,
	"./Hop_dark.png": 488,
	"./Hop_dark.svg": 489,
	"./Synapse.png": 490,
	"./Synapse.svg": 491,
	"./binance.png": 492,
	"./bscscan.png": 493,
	"./btn_big_arbitrum.png": 494,
	"./btn_big_avalanche.png": 495,
	"./btn_big_bsc.png": 496,
	"./btn_big_purchasegmx.png": 497,
	"./btn_big_purchasegmx.svg": 498,
	"./buy_gmx.svg": 285,
	"./buy_gmx_bond.svg": 499,
	"./buy_transfer_eth.svg": 500,
	"./coinbaseWallet.png": 286,
	"./coingecko.png": 501,
	"./cross.svg": 502,
	"./flag_en.svg": 503,
	"./flag_es.svg": 504,
	"./flag_fr.svg": 505,
	"./flag_ja.svg": 506,
	"./flag_ko.svg": 507,
	"./flag_ru.svg": 508,
	"./flag_zh.svg": 509,
	"./glp_icon.svg": 510,
	"./gmx-logo-final-white-small.png": 511,
	"./gmx-logo-final-white.png": 512,
	"./gmx-logo-final.png": 513,
	"./gmx-logo-glow.png": 514,
	"./gmx-logo-with-name.svg": 287,
	"./gmx_logo.svg": 515,
	"./graphite-01.png": 516,
	"./ic-communityproject.svg": 517,
	"./ic_aave_24.svg": 518,
	"./ic_aave_30.svg": 519,
	"./ic_aave_40.svg": 520,
	"./ic_arbitrum_16.svg": 129,
	"./ic_arbitrum_24.svg": 171,
	"./ic_arbitrum_96.svg": 172,
	"./ic_arbitrum_hover_16.svg": 521,
	"./ic_arrowleft16.svg": 522,
	"./ic_arrowright16.svg": 523,
	"./ic_avalanche_16.svg": 524,
	"./ic_avalanche_24.svg": 525,
	"./ic_avalanche_96.svg": 173,
	"./ic_avax_24.svg": 526,
	"./ic_avax_30.svg": 527,
	"./ic_avax_40.svg": 528,
	"./ic_banxa.svg": 529,
	"./ic_binance.svg": 530,
	"./ic_binance_logo.svg": 531,
	"./ic_bsc.svg": 532,
	"./ic_bsc_96.svg": 533,
	"./ic_btc.b_24.svg": 534,
	"./ic_btc.b_40.svg": 535,
	"./ic_btc_24.svg": 536,
	"./ic_btc_40.svg": 537,
	"./ic_bungee.png": 288,
	"./ic_busd_24.svg": 538,
	"./ic_buy_glp.svg": 289,
	"./ic_cash.png": 539,
	"./ic_cash.svg": 540,
	"./ic_checked.svg": 200,
	"./ic_coingecko_16.svg": 290,
	"./ic_coingecko_hover_16.svg": 541,
	"./ic_convert_down.svg": 291,
	"./ic_copy_16.svg": 292,
	"./ic_cost.svg": 293,
	"./ic_dai_24.svg": 542,
	"./ic_dai_40.svg": 543,
	"./ic_discord.svg": 294,
	"./ic_eth_16.svg": 116,
	"./ic_eth_24.svg": 174,
	"./ic_eth_40.svg": 544,
	"./ic_frax_24.svg": 545,
	"./ic_frax_40.svg": 546,
	"./ic_github.svg": 295,
	"./ic_glp_24.svg": 241,
	"./ic_glp_40.svg": 201,
	"./ic_glp_40_.svg": 547,
	"./ic_glp_custom.svg": 296,
	"./ic_glp_custom_.svg": 548,
	"./ic_gmx.svg": 549,
	"./ic_gmx_24.svg": 550,
	"./ic_gmx_30.svg": 551,
	"./ic_gmx_40.svg": 297,
	"./ic_gmx_40_.svg": 552,
	"./ic_gmx_64.svg": 553,
	"./ic_gmx_arbitrum.svg": 554,
	"./ic_gmx_avax.svg": 555,
	"./ic_gmx_big.svg": 556,
	"./ic_gmx_custom.svg": 298,
	"./ic_gmx_custom_.svg": 557,
	"./ic_gmx_footer.svg": 299,
	"./ic_gmx_footer_.svg": 558,
	"./ic_hop.svg": 559,
	"./ic_info.svg": 560,
	"./ic_language24.svg": 175,
	"./ic_link.e_40.svg": 561,
	"./ic_link_24.svg": 562,
	"./ic_link_40.svg": 563,
	"./ic_liquidity.svg": 300,
	"./ic_matic_16.svg": 564,
	"./ic_matic_24.svg": 565,
	"./ic_matic_40.svg": 566,
	"./ic_medium.svg": 301,
	"./ic_menu_dots.svg": 567,
	"./ic_metamask_16.svg": 302,
	"./ic_metamask_hover_16.svg": 568,
	"./ic_mim_24.svg": 569,
	"./ic_mim_40.svg": 570,
	"./ic_multiswap.svg": 571,
	"./ic_new_link_16.svg": 303,
	"./ic_o3.png": 304,
	"./ic_olympus.svg": 572,
	"./ic_olympus_arbitrum.svg": 305,
	"./ic_selector_dropdowns.svg": 573,
	"./ic_settings_16.svg": 242,
	"./ic_settings_24.svg": 574,
	"./ic_sign in_16.svg": 575,
	"./ic_sign_out_16.svg": 306,
	"./ic_simpleswaps.svg": 307,
	"./ic_stats.svg": 308,
	"./ic_stats_big.svg": 576,
	"./ic_synapse.svg": 577,
	"./ic_telegram.svg": 309,
	"./ic_tether_24.svg": 578,
	"./ic_tokens.svg": 579,
	"./ic_totaluser.svg": 310,
	"./ic_traderjoe.png": 580,
	"./ic_trading.svg": 311,
	"./ic_transfer_avax.svg": 581,
	"./ic_twitter.svg": 312,
	"./ic_uni_24.svg": 582,
	"./ic_uni_40.svg": 583,
	"./ic_uni_arbitrum.svg": 313,
	"./ic_uniswap.png": 314,
	"./ic_usdc.e_24.svg": 584,
	"./ic_usdc.e_40.svg": 585,
	"./ic_usdc_24.svg": 586,
	"./ic_usdc_40.svg": 587,
	"./ic_usdt_24.svg": 588,
	"./ic_usdt_40.svg": 589,
	"./ic_wallet_24.svg": 315,
	"./ic_wavax_24.svg": 590,
	"./ic_wavax_40.svg": 591,
	"./ic_wbtc_24.svg": 592,
	"./ic_wbtc_40.svg": 593,
	"./ic_weth_24.svg": 594,
	"./ic_weth_40.svg": 595,
	"./lg_arbitrum.svg": 596,
	"./logo_GMX.svg": 176,
	"./logo_GMX_.svg": 597,
	"./logo_GMX_small.svg": 243,
	"./logo_GMX_small_.svg": 598,
	"./long.svg": 316,
	"./metamask-text.svg": 599,
	"./metamask.png": 317,
	"./page-not-found.svg": 600,
	"./position-share-bg.png": 318,
	"./short.svg": 319,
	"./swap.svg": 320,
	"./trading.jpg": 601,
	"./wallet-connect-text.svg": 602,
	"./walletconnect-circle-blue.svg": 321,
	"./wave-01.png": 603,
	"./wave-02.png": 604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 479;